/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteConsultantCommand
 */
export interface DeleteConsultantCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteConsultantCommand
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteConsultantCommand
     */
    consultantId: number;
}

/**
 * Check if a given object implements the DeleteConsultantCommand interface.
 */
export function instanceOfDeleteConsultantCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "consultantId" in value;

    return isInstance;
}

export function DeleteConsultantCommandFromJSON(json: any): DeleteConsultantCommand {
    return DeleteConsultantCommandFromJSONTyped(json, false);
}

export function DeleteConsultantCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteConsultantCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['ProductId'],
        'consultantId': json['ConsultantId'],
    };
}

export function DeleteConsultantCommandToJSON(value?: DeleteConsultantCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductId': value.productId,
        'ConsultantId': value.consultantId,
    };
}

